import { render } from "./Counseling.vue?vue&type=template&id=74c6db20"
import script from "./Counseling.vue?vue&type=script&lang=js"
export * from "./Counseling.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Counseling.vue?vue&type=style&index=0&id=74c6db20&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__